import {useDispatch, useSelector} from "react-redux";
import ModalBody from "../../../core/Modal/ModalBody/ModalBody";
import Button from "../../../core/Button/Button";
import React from "react";
import {closeLobbyModal} from "../../../redux/actions/lobby/actions";
import {useTranslation} from "react-i18next";
import {joinRoom} from "../../../redux/actions/cash/actions.js";

function ServerBonusInfoModal() {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const {roomId, bonusAmount, realAmount} = useSelector(state => state.lobby.server);
    const currency = useSelector(state => state.user.currency);
    const handleJoinRoom = () => {
        dispatch(joinRoom({roomId: roomId, isBonus: false}));
        dispatch(closeLobbyModal())
    };
    return <>
        <ModalBody>
            <div className="server-info-modal">
                <p>{t(`server.bonus_room_info`,{"realAmount": `${realAmount?.[currency]} ${currency}`,"bonusAmount":`${bonusAmount?.[currency]} ${currency}`})}</p>
                <div className="server-info-modal__buttons">
                    <Button
                        onClick={() => handleJoinRoom()}
                        type={"yellow"}
                        text={t("modals.buttons.ok")}
                    />
                    <Button
                        onClick={() => dispatch(closeLobbyModal())}
                        type={"red"}
                        text={t("modals.buttons.close")}
                    />
                </div>
            </div>
        </ModalBody>
    </>


}

export default ServerBonusInfoModal